import { render, staticRenderFns } from "./vliveFollow.vue?vue&type=template&id=a6517fb4&"
import script from "./vliveFollow.vue?vue&type=script&lang=js&"
export * from "./vliveFollow.vue?vue&type=script&lang=js&"
import style0 from "./vliveFollow.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports